import {useEntrancePopup} from '@/framework/popup';
import {useModalAction, useModalState} from '@/_application/core/components/ui/modal/modal.context';
import {useEffect, useMemo, useRef, useState} from 'react';

export const useEntrancePopupController = () => {
    const {openModal} = useModalAction();
    const {isOpen: modalAlreadyOpen} = useModalState();
    const {data} = useEntrancePopup();
    const validData = useMemo(() => data?.filter(item => item), [data]);
    const timerRef = useRef<NodeJS.Timeout | null>(null);
    const [shouldDisplayPopup, setShouldDisplayPopup] = useState(false);

    useEffect(() => {
        if (!validData?.length) return;

        const isCurrentSession = sessionStorage.getItem('bssPopup');
        if (!isCurrentSession) {
            const handleScroll = () => {
                sessionStorage.setItem('bssPopup', 'displayed');
                timerRef.current = setTimeout(() => {
                    setShouldDisplayPopup(true);
                }, 10000); // 10 seconds delay
                window.removeEventListener('scroll', handleScroll);
            };

            window.addEventListener('scroll', handleScroll);

            return () => {
                if (timerRef.current) {
                    clearTimeout(timerRef.current);
                }
                window.removeEventListener('scroll', handleScroll);
            };
        }
    }, [validData]);

    // only open entrance popup if no other modal is in display
    useEffect(() => {
        if (shouldDisplayPopup && !modalAlreadyOpen) {
            setShouldDisplayPopup(false);
            openModal('ENTRANCE_POPUP', {validData});
        }
    }, [shouldDisplayPopup, modalAlreadyOpen]);
};
